var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9375 36 36 27.9414 36 18C36 8.05859 27.9375 0 18 0C8.0625 0 0 8.05859 0 18C0 27.9414 8.0625 36 18 36ZM8.625 10.3516V26H12.1484V10.3516H8.625ZM15.8438 10.3516V26H20.4453C21.4062 26 22.2891 25.8906 23.0938 25.6719C23.5781 25.543 24.0312 25.3711 24.4531 25.1602C25.6094 24.5859 26.5078 23.7109 27.1406 22.543C27.7812 21.375 28.1016 19.8945 28.1016 18.1055C28.1016 17.2461 28.0234 16.4609 27.875 15.7539C27.7109 14.9844 27.4609 14.3047 27.1172 13.7109C26.4766 12.5586 25.5781 11.7109 24.4062 11.168C23.7188 10.8477 22.9609 10.6211 22.125 10.4883C21.5391 10.3984 20.9141 10.3516 20.2578 10.3516H15.8438ZM20.0391 23.1445H19.3672V13.207H20.0391C20.9375 13.207 21.7109 13.3594 22.3672 13.6641C23.0391 13.9531 23.5625 14.457 23.9297 15.1758C24.2969 15.8789 24.4766 16.8555 24.4766 18.1055C24.4766 19.3516 24.2969 20.3438 23.9297 21.0781C23.7344 21.4648 23.5 21.793 23.2266 22.0664C22.9766 22.3125 22.6875 22.5117 22.3672 22.6641C21.7109 22.9844 20.9375 23.1445 20.0391 23.1445Z",
    fill: "#A8071A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/IDIcon.342ecd5af2e3f2ca332c98bf7d7cc6ff.svg";
export { ForwardRef as ReactComponent };